import { FileUpload } from '@driftt/api-types'
import { AxiosRequestConfig } from 'axios'

import { FileAPI } from 'api'

interface FileUploadRequestConfig extends AxiosRequestConfig {
  raw?: boolean
}

export const upload = async (fileData: string | Blob) => {
  const data = new FormData()
  const config: FileUploadRequestConfig = {
    raw: true,
    headers: {},
  }

  data.append('file', fileData)
  return FileAPI.post<FileUpload>(
    '/upload',
    data,
    config as any /* eslint-disable-line @typescript-eslint/no-explicit-any */
  )
}
